/* global window, document */
require('public/css/catalog.scss');
const {
	getAvailableSearchFacetQueryNames,
} = require('public/js/components/search-facets');
const additionalSearchFilterHelpers = require('public/templates/components/additional_search_filters/utils');

var THE_SCRIPT = function () {
	const $onReady = require('./lib/on-ready');
	const { trackCategoryListEvent } = require('public/js/lib/adobe-dtm-helper');

	let searchFacetParams = []; // set after onReady
	const catalog = {
		getCategoryId: function () {
			return parseInt(rp$('.catalog-products').data('category'));
		},
	};

	catalog.getSearchResults = function (changedField, params) {
		let historyUrl = null;
		if (changedField !== 'history') {
			historyUrl = catalog.buildHistoryUrl(params);
		}

		if (window.__DISABLE_SEARCH_HISTORY_HANDLER) {
			rp_app.location.redirect(historyUrl);
			return;
		}

		rp$(document).trigger('searchResults:request');
		$ajax({
			method: 'GET',
			dataType: 'json',
			data: params,
			url: this.buildFetchUrl(),
			error: (/*j, textStatus, error*/) => {
				rp$(document).trigger('searchResults:error');
			},
			success: (response/*, status, xhr*/) => {
				if (historyUrl !== null) {
					try {
						window.history.pushState({}, '', historyUrl);
					}
					catch (e) {/* TODO: For now, ignoring IE9 and below.. revisit when we do full filtering sidebar */ }
				}

				rp$(document).trigger('searchResults:response', response);
			}
		});
	};

	catalog.buildFetchUrl = function () {
		switch (this.type) {
			case 'refresh-assemblies':
				return `/ajax/oem-assemblies-search/${this.groupAndSubgroup}`;
			case 'catalog-c':
				return `/ajax/catalog/c-${catalog.getCategoryId()}`;
			default:
				return `/ajax/catalog/c-${catalog.getCategoryId()}`;
		}
	};

	catalog.buildHistoryUrl = function (requestParams) {
		let baseUrl = rp$('base').attr('href');
		if (!baseUrl || typeof baseUrl === 'string') {
			baseUrl = rp_app.location.getBase();
		}
		const currentPath = rp_app.location.pathname.replace(/^\//, '');
		const targetParams = rp$.extend(rp_app.query.all(), requestParams);

		return baseUrl + '/' + currentPath + '?' + rp$.param(targetParams);
	};

	catalog.handleHistoryChange = function (/*evt*/) {
		const args = rp_app.query.all(rp_app.location.href);
		const params = {
			page: args.page,
		};

		catalog.getSearchResults('history', params);
	};

	catalog.handlePageChange = function (pageNum) {
		const args = rp_app.query.all(rp_app.location.href);
		const additionalFilters = additionalSearchFilterHelpers.getAdditionalFilterValuesFromDom();

		const params = {
			page: pageNum,
			...additionalFilters
		};
		searchFacetParams.forEach((facet) => {
			if (args[facet]) {
				params[facet] = decodeURIComponent(args[facet]);
			}
		});
		catalog.getSearchResults('page', params);
	};

	if (!window.__DISABLE_SEARCH_HISTORY_HANDLER) {
		window.addEventListener('popstate', catalog.handleHistoryChange);

		rp$(document).on('searchResults:pageChange', function handlePageChange(evt, pageNum) {
			evt.preventDefault();
			catalog.handlePageChange(pageNum);
		});
	}

	$onReady({
		rp$, window,
		label: 'catalog',
		fn: function () {
			searchFacetParams = getAvailableSearchFacetQueryNames();
			const productRows = rp$('.catalog-product.marketplace-product');
			// Track Adobe DTM category page view
			if (productRows.length) {
				trackCategoryListEvent();
			}

			const $additionalFilters = rp$('.additional-filter-form');
			if ($additionalFilters.length > 0) {
				$additionalFilters.on('changeAdditionalFilters', function handleAdditionalFilterChange(evt, filters) {
					catalog.type = 'catalog-c';
					catalog.getSearchResults('', filters);
				});
			}

			const groupAndSubgroup = window.location.pathname.split('/')[2];
			if (groupAndSubgroup) {
				catalog.groupAndSubgroup = groupAndSubgroup;
			}

			const $facetsModule = rp$('.search-facets-module');
			if ($facetsModule.length > 0) {
				$facetsModule.on('selectedFacetBucketsChanged', function handleSelectedBucketsChange(e, queryParams) {
					catalog.type = catalog.getCategoryId() ? 'catalog-c' : 'refresh-assemblies';
					// Factor existing vehicle filter params into search
					const additionalFilters = additionalSearchFilterHelpers.getAdditionalFilterValuesFromDom();
					const updatedParams = { ...queryParams, ...additionalFilters };
					catalog.getSearchResults('', updatedParams);
				});
			}
		},
	});
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
